"use strict";
var appn;
(function (appn) {
    var actionButtons;
    (function (actionButtons) {
        actionButtons.BUTTONS = appn.actionButtons.BUTTONS;
        const _buttonTemplate = '<button id="%0%" class="btn %1% %5%" %4%><span>%2%</span><i class="%3%"></i></button>';
        function getButton(buttonId, buttonType, isDisabled, buttonText, isDataTableToggleBtn) {
            const currentBtn = appn.actionButtons.BUTTONS[buttonType];
            let button = _buttonTemplate.replace('%0%', buttonId)
                .replace('%1%', currentBtn.ButtonColourClass)
                .replace('%2%', buttonText ? buttonText : T(currentBtn.Text))
                .replace('%3%', currentBtn.IconClass);
            if (isDataTableToggleBtn) {
                button = button.replace('%5%', 'btn-sm datatable-togglebtn');
                isDisabled = true;
            }
            else
                button = button.replace('%5%', appn.emptyString);
            if (isDisabled)
                button = button.replace('%4%', 'disabled="disabled"');
            else
                button = button.replace('%4%', appn.emptyString);
            return button;
        }
        actionButtons.getButton = getButton;
        function getButtonAndAppendTo(buttonId, buttonType, appendTo, isDisabled, buttonText, isDataTableToggleBtn) {
            $('#' + buttonId).remove();
            appendTo.append(getButton(buttonId, buttonType, isDisabled, buttonText, isDataTableToggleBtn));
        }
        actionButtons.getButtonAndAppendTo = getButtonAndAppendTo;
        function getButtonAndPrependTo(buttonId, buttonType, prependTo, isDisabled, buttonText, isDataTableToggleBtn) {
            $('#' + buttonId).remove();
            prependTo.prepend(getButton(buttonId, buttonType, isDisabled, buttonText, isDataTableToggleBtn));
        }
        actionButtons.getButtonAndPrependTo = getButtonAndPrependTo;
        function renderNavbarActionButtons(actionButtonConfigs, userIsPermitted, appendToDataTableAction) {
            if (!userIsPermitted || !actionButtonConfigs || actionButtonConfigs.length < 1)
                return;
            const $toolbar = !appendToDataTableAction ? $('.navbar-nav-right') : $('.dataTables_controls_start');
            for (let i = 0; i < actionButtonConfigs.length; i++)
                getButtonAndAppendTo(actionButtonConfigs[i].buttonId, actionButtonConfigs[i].buttonType, $toolbar, actionButtonConfigs[i].isDisabled, actionButtonConfigs[i].buttonText, actionButtonConfigs[i].isDataTableToggleBtn);
        }
        actionButtons.renderNavbarActionButtons = renderNavbarActionButtons;
    })(actionButtons = appn.actionButtons || (appn.actionButtons = {}));
})(appn || (appn = {}));
